import { roomState, setTrackState } from '../webRTCRoom'

/**
 * Toggles the video track of the local participant.
 */
const toggleVideo = async () => {
  const localParticipant = roomState.participants.find((p) => p.isLocal)
  if (!localParticipant?.tracks.camera) return undefined

  return setTrackState('camera', !localParticipant.tracks.camera.isEnabled)
}

export { toggleVideo }
